import { useEffect, useState } from 'react';
import { fetchPersonals } from '../../http/personalAPI';
import Card from 'antd/es/card/Card';
import { $host } from "../../http";
import './style.scss';


const Personals = () => {
    const [personals, setPersonals] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const language = localStorage.getItem("lang") ? localStorage.getItem("lang") : 'am'
    const fullName = `fullName${language.toUpperCase()}`;
    const position = `position${language.toUpperCase()}`;

    useEffect(() => {
        const getPersonals = async () => {
            try {
                const data = await fetchPersonals();
                setPersonals(data);
            } catch (err) {
                console.error("Error fetching personals:", err);
                setError("Failed to load personals");
            } finally {
                setLoading(false);
            }
        };
        getPersonals();
    }, []);

    if (loading) {
        return <div>Loading personals...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (<div className='personal-container'> {personals.length > 0 ? (
        personals.map((personal, index) => (
            <Card key={index} className='personal-card'>
                <img  className='personal-image' src={$host.defaults.baseURL + 'photos/personal/' + (personal.img_main ? personal.img_main : 'docdefault.jpg')} alt={personal.fullName} />
                <div className="doctor-info">
                    <h3>{personal[fullName]}</h3>
                    <p>{personal[position]}</p> </div>
            </Card>))) : (<p>No personals found.</p>)} </div>);

}; export default Personals;